/**
 * @one-payments/adapters-web - Web platform adapters
 * @module @one-payments/adapters-web
 */

import type { Adapters } from '@one-payments/core';
import { WebHttpAdapter } from './http.js';
import { WebStorageAdapter } from './storage.js';
import { WebCryptoAdapter } from './crypto.js';
import { WebTimerAdapter } from './timer.js';

export { WebHttpAdapter } from './http.js';
export { WebStorageAdapter } from './storage.js';
export { WebCryptoAdapter } from './crypto.js';
export { WebTimerAdapter } from './timer.js';

/**
 * Create web adapters - convenience factory function
 */
export function createWebAdapters(): Adapters {
  return {
    http: new WebHttpAdapter(),
    storage: new WebStorageAdapter(),
    crypto: new WebCryptoAdapter(),
    timer: new WebTimerAdapter(),
  };
}
